(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', './Grade'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./Grade'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.RecmdContentProfile = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Grade);
  }
}(this, function(ApiClient, Grade) {
  'use strict';

  /**
   * The RecmdContentProfile model module.
   * @module model/RecmdContentProfile
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>RecmdContentProfile</code>.
   * @alias module:model/RecmdContentProfile
   * @class
   */
  var exports = function() {
















  };

  /**
   * Constructs a <code>RecmdContentProfile</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RecmdContentProfile} obj Optional instance to populate.
   * @return {module:model/RecmdContentProfile} The populated <code>RecmdContentProfile</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('tags')) {
        obj['tags'] = ApiClient.convertToType(data['tags'], ['String']);
      }
      if (data.hasOwnProperty('author')) {
        obj['author'] = ApiClient.convertToType(data['author'], 'String');
      }
      if (data.hasOwnProperty('category')) {
        obj['category'] = ApiClient.convertToType(data['category'], 'String');
      }
      if (data.hasOwnProperty('clientPlatform')) {
        obj['clientPlatform'] = ApiClient.convertToType(data['clientPlatform'], 'String');
      }
      if (data.hasOwnProperty('contentId')) {
        obj['contentId'] = ApiClient.convertToType(data['contentId'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('grade')) {
        obj['grade'] = Grade.constructFromObject(data['grade']);
      }
      if (data.hasOwnProperty('lastAccessed')) {
        obj['lastAccessed'] = ApiClient.convertToType(data['lastAccessed'], 'Integer');
      }
      if (data.hasOwnProperty('ownerId')) {
        obj['ownerId'] = ApiClient.convertToType(data['ownerId'], 'String');
      }
      if (data.hasOwnProperty('previewUrl')) {
        obj['previewUrl'] = ApiClient.convertToType(data['previewUrl'], 'String');
      }
      if (data.hasOwnProperty('shareId')) {
        obj['shareId'] = ApiClient.convertToType(data['shareId'], 'String');
      }
      if (data.hasOwnProperty('sharedDate')) {
        obj['sharedDate'] = ApiClient.convertToType(data['sharedDate'], 'Integer');
      }
      if (data.hasOwnProperty('subjects')) {
        obj['subjects'] = ApiClient.convertToType(data['subjects'], ['String']);
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('uploadedDate')) {
        obj['uploadedDate'] = ApiClient.convertToType(data['uploadedDate'], 'Integer');
      }
    }
    return obj;
  }


  /**
   * @member {Array.<String>} tags
   */
  exports.prototype['tags'] = undefined;

  /**
   * @member {String} author
   */
  exports.prototype['author'] = undefined;

  /**
   * @member {module:model/RecmdContentProfile.CategoryEnum} category
   */
  exports.prototype['category'] = undefined;

  /**
   * @member {module:model/RecmdContentProfile.ClientPlatformEnum} clientPlatform
   */
  exports.prototype['clientPlatform'] = undefined;

  /**
   * @member {String} contentId
   */
  exports.prototype['contentId'] = undefined;

  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;

  /**
   * @member {module:model/Grade} grade
   */
  exports.prototype['grade'] = undefined;

  /**
   * @member {Integer} lastAccessed
   */
  exports.prototype['lastAccessed'] = undefined;

  /**
   * @member {String} ownerId
   */
  exports.prototype['ownerId'] = undefined;

  /**
   * @member {String} previewUrl
   */
  exports.prototype['previewUrl'] = undefined;

  /**
   * @member {String} shareId
   */
  exports.prototype['shareId'] = undefined;

  /**
   * @member {Integer} sharedDate
   */
  exports.prototype['sharedDate'] = undefined;

  /**
   * @member {Array.<String>} subjects
   */
  exports.prototype['subjects'] = undefined;

  /**
   * @member {String} title
   */
  exports.prototype['title'] = undefined;

  /**
   * @member {Integer} uploadedDate
   */
  exports.prototype['uploadedDate'] = undefined;


  /**
   * Allowed values for the <code>category</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CategoryEnum = { 
    /**
     * value: MATH
     * @const
     */
    MATH: "MATH",
    
    /**
     * value: ART
     * @const
     */
    ART: "ART",
    
    /**
     * value: SCIENCE
     * @const
     */
    SCIENCE: "SCIENCE"
  };  /**
   * Allowed values for the <code>clientPlatform</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ClientPlatformEnum = { 
    /**
     * value: SLO
     * @const
     */
    SLO: "SLO",
    
    /**
     * value: CP
     * @const
     */
    CP: "CP",
    
    /**
     * value: AMP
     * @const
     */
    AMP: "AMP",
    
    /**
     * value: AMP_WS
     * @const
     */
    AMP_WS: "AMP_WS"
  };

  return exports;
}));
